import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 24 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    data-ffid='icn-plp-wishlist-empty-heart'
  >
    <path
      d="M11.6667 21.4083L9.975 19.8917C8.01111 18.1222 6.3875 16.5958 5.10417 15.3125C3.82083 14.0292 2.8 12.8771 2.04167 11.8563C1.28333 10.8354 0.753472 9.89722 0.452083 9.04167C0.150695 8.18611 0 7.31111 0 6.41667C0 4.58889 0.6125 3.0625 1.8375 1.8375C3.0625 0.6125 4.58889 0 6.41667 0C7.42778 0 8.39028 0.213889 9.30417 0.641667C10.2181 1.06944 11.0056 1.67222 11.6667 2.45C12.3278 1.67222 13.1153 1.06944 14.0292 0.641667C14.9431 0.213889 15.9056 0 16.9167 0C18.7444 0 20.2708 0.6125 21.4958 1.8375C22.7208 3.0625 23.3333 4.58889 23.3333 6.41667C23.3333 7.31111 23.1826 8.18611 22.8813 9.04167C22.5799 9.89722 22.05 10.8354 21.2917 11.8563C20.5333 12.8771 19.5125 14.0292 18.2292 15.3125C16.9458 16.5958 15.3222 18.1222 13.3583 19.8917L11.6667 21.4083ZM11.6667 18.2583C13.5333 16.5861 15.0694 15.1521 16.275 13.9563C17.4806 12.7604 18.4333 11.7201 19.1333 10.8354C19.8333 9.9507 20.3194 9.1632 20.5917 8.47292C20.8639 7.78264 21 7.09722 21 6.41667C21 5.25 20.6111 4.27778 19.8333 3.5C19.0556 2.72222 18.0833 2.33333 16.9167 2.33333C16.0028 2.33333 15.1569 2.59097 14.3792 3.10625C13.6014 3.62153 13.0667 4.27778 12.775 5.075H10.5583C10.2667 4.27778 9.73195 3.62153 8.95417 3.10625C8.17639 2.59097 7.33056 2.33333 6.41667 2.33333C5.25 2.33333 4.27778 2.72222 3.5 3.5C2.72222 4.27778 2.33333 5.25 2.33333 6.41667C2.33333 7.09722 2.46944 7.78264 2.74167 8.47292C3.01389 9.1632 3.5 9.9507 4.2 10.8354C4.9 11.7201 5.85278 12.7604 7.05833 13.9563C8.26389 15.1521 9.8 16.5861 11.6667 18.2583Z"
      fill="currentColor"
    />
  </svg>
);

export default Icon;
